import { createStore } from "vuex";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default createStore({
  state: {
    paused: false,
    mediaVolume: 0.0,
    offline: false,
    appMode: null,
    screenMode: "active",
    sessionId: null,
    interactionSequence: 0,
    activeAjaxRequests: 0,
    activeAudioRequests: 0,
    activeImageRequests: 0,
    locale: null,
    content: {},
    muted: false,
    prevHistory: "",
    trackingData: {
      isMedia: false,
      mediaType: "null",
      mediaKey: "null",
    },
    audioFiles: [],
    preloadedAssets: {},
    audioLocations: [
      { key: "selection.indonesia" },
      { key: "selection.maldives" },
      { key: "selection.kenya" },
      { key: "selection.mexico" },
      { key: "selection.australia" },
      { key: "selection.phillipines" },

      { key: "selection.frenchpolynesia" },

      { key: "selection.panama" },
      { key: "selection.belgium" },
      { key: "selection.florida" },
      { key: "selection.sweden" },
      { key: "selection.canada" },
    ],
    selectedAudioLocation: "selection.phillipines",
    locations: {
      1: {
        steps: {
          1: {
            answer: 1,
            options: [
              {
                id: 1,
                key: "Fish",
                value: 1,
              },

              {
                id: 2,
                key: "Snapping shrimp",
                value: 2,
              },

              {
                id: 3,
                key: "Motor boat",
                value: 3,
              },

              {
                id: 4,
                key: "Bubbles",
                value: 4,
              },
            ],
          },

          2: {
            answer: 3,
            options: [
              {
                id: 1,
                key: "Diver",
                value: 1,
              },

              {
                id: 2,
                key: "Motor boat",
                value: 2,
              },

              {
                id: 3,
                key: "Snapping shrimp",
                value: 3,
              },

              {
                id: 4,
                key: "Crab",
                value: 4,
              },
            ],
          },

          3: {
            answer: 2,
            options: [
              {
                id: 1,
                key: "Motor boat",
                value: 1,
              },

              {
                id: 2,
                key: "Fish",
                value: 2,
              },

              {
                id: 3,
                key: "Crab",
                value: 3,
              },

              {
                id: 4,
                key: "Sea birds",
                value: 4,
              },
            ],
          },

          4: {
            answer: 3,
            options: [
              {
                id: 1,
                key: "Divers",
                value: 1,
              },

              {
                id: 2,
                key: "Snapping shrimp",
                value: 2,
              },

              {
                id: 3,
                key: "Fish",
                value: 3,
              },

              {
                id: 4,
                key: "Motor boat",
                value: 4,
              },
            ],
          },

          5: {
            answer: 4,
            options: [
              {
                id: 1,
                key: "Divers",
                value: 1,
              },

              {
                id: 2,
                key: "Snapping shrimp",
                value: 2,
              },

              {
                id: 3,
                key: "Mining",
                value: 3,
              },

              {
                id: 4,
                key: "Motor boat",
                value: 4,
              },
            ],
          },

          6: {
            answer: 1,
            options: [
              {
                id: 1,
                key: "Fish",
                value: 1,
              },

              {
                id: 2,
                key: "Shipping",
                value: 2,
              },

              {
                id: 3,
                key: "Crabs",
                value: 3,
              },

              {
                id: 4,
                key: "Dolphins",
                value: 4,
              },
            ],
          },
        },
      },
    },
  },

  getters,
  mutations,
  actions,

  modules: {},
});
